import React, { useState } from 'react';
export function App() {
  const [activeNode, setActiveNode] = useState<number | null>(null);
  return <div className="w-full min-h-screen bg-[#F1F5F9] overflow-x-hidden" data-id="element-0">
      {/* SECTION 1 — HERO */}
      <section className="w-full bg-[#09111F] relative overflow-hidden" data-id="element-1">
        {/* Decorative Background Elements */}
        <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:24px_24px]" data-id="element-2"></div>
        <div className="absolute top-[-120px] right-[-120px] w-[500px] h-[500px] rounded-full bg-[#1D4ED8] opacity-20 blur-[80px]" data-id="element-3"></div>
        <div className="absolute bottom-[-80px] left-[-100px] w-[300px] h-[300px] rounded-full bg-[#3B82F6] opacity-10 blur-[60px]" data-id="element-4"></div>

        <div className="max-w-[1200px] mx-auto px-5 md:px-12 py-16 md:py-24 relative z-10" data-id="element-5">
          <div className="flex flex-col lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center" data-id="element-6">
            {/* Badge + Title — always first on mobile, part of left column on desktop */}
            <div className="order-1 lg:order-none text-center lg:text-left flex flex-col items-center lg:items-start mb-8 lg:mb-0 lg:row-span-1" data-id="element-7">
              <div className="inline-flex items-center gap-2 bg-[rgba(255,255,255,0.03)] border border-[rgba(255,255,255,0.08)] backdrop-blur-sm px-4 py-2 rounded-full mb-6 shadow-[0_4px_20px_rgba(0,0,0,0.2)]" data-id="element-8">
                <div className="w-2 h-2 rounded-full bg-[#3B82F6] animate-pulse" data-id="element-9"></div>
                <span className="font-['Montserrat'] text-[11px] font-bold tracking-[0.18em] uppercase text-[#3B82F6]" data-id="element-10">
                  IMPLEMENTARE SISTEME DE BUSINESS
                </span>
              </div>

              <h1 className="font-['Montserrat'] text-[clamp(32px,4.5vw,56px)] font-extrabold text-white leading-[1.1] mb-0 lg:mb-6 tracking-tight" data-id="element-11">
                Din compania care depinde de tine, la afacerea care merge fără
                tine.
              </h1>

              {/* Paragraph + CTA — hidden on mobile, shown on desktop */}
              <div className="hidden lg:block" data-id="element-12">
                <p className="font-['Inter'] text-[19px] font-light text-[rgba(255,255,255,0.7)] leading-[1.8] mb-8 max-w-[600px]" data-id="element-13">
                  Vin în compania ta, lucrez alături de tine și de echipa ta de
                  lideri și implementez "PROVI System" pas cu pas, astfel încât
                  afacerea ta să producă rezultate predictibile, să crească și
                  să meargă fără implicarea ta zilnică.
                </p>

                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-6" data-id="element-14">
                  <a href="https://calendly.com/valerdura-coaching/sesiune-descoperire" className="font-['Montserrat'] text-[15px] font-semibold bg-[#1D4ED8] text-white px-8 py-4 rounded-xl shadow-[0_8px_24px_rgba(29,78,216,0.4)] hover:bg-[#2563EB] hover:-translate-y-1 transition-all duration-300 w-full sm:w-auto text-center inline-block no-underline" data-id="element-15">
                    Vreau o Diagnosticare Gratuită a Companiei
                  </a>
                </div>

                <div className="flex items-start gap-3 max-w-[500px]" data-id="element-16">
                  <svg className="w-5 h-5 text-[#3B82F6] flex-shrink-0 mt-0.5 opacity-70" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-17">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-18"></path>
                  </svg>
                  <p className="font-['Inter'] text-[15px] text-[rgba(255,255,255,0.6)] leading-[1.7]" data-id="element-19">
                    Dacă muncești la fel de mult ca acum 3 ani și afacerea tot
                    nu crește, problema nu ești tu. E lipsa sistemului.
                  </p>
                </div>
              </div>
            </div>

            {/* Photo — second on mobile, right column on desktop */}
            <div className="order-2 lg:order-none relative w-full max-w-[400px] lg:max-w-[500px] mx-auto lg:ml-auto mb-8 lg:mb-0" data-id="element-20">
              {/* Large Glowing Halo Behind Photo */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[110%] h-[110%] rounded-full bg-[#1D4ED8] opacity-[0.15] blur-[60px] z-0" data-id="element-21"></div>

              {/* Animated Concentric Rings */}
              <svg className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[130%] h-[130%] z-0" viewBox="0 0 400 400" fill="none" data-id="element-22">
                <circle cx="200" cy="200" r="180" stroke="#1D4ED8" strokeWidth="1" opacity="0.2" strokeDasharray="8 6" data-id="element-23">
                  <animateTransform attributeName="transform" type="rotate" from="0 200 200" to="360 200 200" dur="60s" repeatCount="indefinite" data-id="element-24" />
                </circle>
                <circle cx="200" cy="200" r="160" stroke="#3B82F6" strokeWidth="0.5" opacity="0.15" strokeDasharray="4 8" data-id="element-25">
                  <animateTransform attributeName="transform" type="rotate" from="360 200 200" to="0 200 200" dur="45s" repeatCount="indefinite" data-id="element-26" />
                </circle>
                <circle cx="200" cy="200" r="195" stroke="#1D4ED8" strokeWidth="0.5" opacity="0.1" data-id="element-27" />
              </svg>

              {/* Dot Grid — Top Right */}
              <svg className="absolute -top-10 -right-10 w-40 h-40 text-[#3B82F6] opacity-60 z-0" fill="currentColor" viewBox="0 0 120 120" data-id="element-28">
                <pattern id="hero-dots" x="0" y="0" width="16" height="16" patternUnits="userSpaceOnUse" data-id="element-29">
                  <circle cx="2" cy="2" r="1.5" data-id="element-30" />
                </pattern>
                <rect width="120" height="120" fill="url(#hero-dots)" data-id="element-31" />
              </svg>

              {/* Dot Grid — Bottom Left */}
              <svg className="absolute -bottom-8 -left-8 w-28 h-28 text-[#3B82F6] opacity-40 z-0" fill="currentColor" viewBox="0 0 100 100" data-id="element-32">
                <pattern id="hero-dots-bl" x="0" y="0" width="16" height="16" patternUnits="userSpaceOnUse" data-id="element-33">
                  <circle cx="2" cy="2" r="1.5" data-id="element-34" />
                </pattern>
                <rect width="100" height="100" fill="url(#hero-dots-bl)" data-id="element-35" />
              </svg>

              {/* Corner Accent — Top Left */}
              <svg className="absolute -top-4 -left-4 w-16 h-16 z-20" viewBox="0 0 60 60" fill="none" data-id="element-36">
                <path d="M2 20V4a2 2 0 012-2h16" stroke="#1D4ED8" strokeWidth="2.5" strokeLinecap="round" opacity="0.8" data-id="element-37" />
              </svg>

              {/* Corner Accent — Bottom Right */}
              <svg className="absolute -bottom-4 -right-4 w-16 h-16 z-20" viewBox="0 0 60 60" fill="none" data-id="element-38">
                <path d="M58 40v16a2 2 0 01-2 2H40" stroke="#1D4ED8" strokeWidth="2.5" strokeLinecap="round" opacity="0.8" data-id="element-39" />
              </svg>

              {/* Floating Badge — Top Right: PROVI System */}
              <div className="absolute -top-3 -right-3 z-30 bg-[#1D4ED8] text-white font-['Montserrat'] text-[11px] font-bold tracking-wider px-4 py-2 rounded-full shadow-[0_4px_20px_rgba(29,78,216,0.5)] animate-[float_3s_ease-in-out_infinite]" data-id="element-40">
                PROVI SYSTEM
              </div>

              {/* Floating Badge — Bottom Left: Experience */}
              <div className="absolute -bottom-8 -left-6 z-30 bg-[rgba(255,255,255,0.1)] backdrop-blur-md border border-[rgba(255,255,255,0.2)] text-white font-['Montserrat'] text-[11px] font-bold tracking-wider px-4 py-2 rounded-full shadow-[0_4px_20px_rgba(0,0,0,0.3)] animate-[float_3s_ease-in-out_infinite_0.5s]" data-id="element-41">
                <span className="text-[#3B82F6] text-[15px] mr-1" data-id="element-42">32+</span> ANI
                ÎN ANTREPRENORIAT
              </div>

              {/* Decorative Plus Signs */}
              <div className="absolute top-[15%] -left-10 text-[#1D4ED8] opacity-50 text-2xl font-light z-0 animate-pulse" data-id="element-43">
                +
              </div>
              <div className="absolute bottom-[20%] -right-8 text-[#3B82F6] opacity-40 text-xl font-light z-0 animate-pulse" style={{
              animationDelay: '1s'
            }} data-id="element-44">
                +
              </div>
              <div className="absolute top-[60%] -left-6 text-[#3B82F6] opacity-30 text-lg font-light z-0 animate-pulse" style={{
              animationDelay: '2s'
            }} data-id="element-45">
                +
              </div>

              {/* Small Floating Diamonds */}
              <div className="absolute top-[10%] right-[15%] w-2 h-2 bg-[#3B82F6] opacity-60 rotate-45 z-0 animate-ping" style={{
              animationDuration: '3s'
            }} data-id="element-46"></div>
              <div className="absolute bottom-[30%] left-[10%] w-1.5 h-1.5 bg-[#1D4ED8] opacity-50 rotate-45 z-0 animate-ping" style={{
              animationDuration: '4s'
            }} data-id="element-47"></div>

              {/* Main Image Container */}
              <div className="relative z-10 rounded-2xl overflow-hidden border-2 border-[rgba(29,78,216,0.3)] shadow-[0_20px_60px_rgba(29,78,216,0.25),0_0_0_1px_rgba(255,255,255,0.05)] group" data-id="element-48">
                <div className="absolute inset-0 bg-gradient-to-t from-[#09111F] via-transparent to-transparent opacity-60 z-10" data-id="element-49"></div>
                <img src="https://cdn.magicpatterns.com/uploads/fWFHPTDBhfM1RiRRjS7QNx/Valer_1.jpg" alt="Valer Dura" className="w-full h-auto object-cover" data-id="element-50" />
                <div className="absolute bottom-6 left-6 z-20" data-id="element-51">
                  <p className="font-['Montserrat'] text-white font-bold text-lg" data-id="element-52">
                    Valer Dura
                  </p>
                  <p className="font-['Inter'] text-[#3B82F6] text-sm font-medium" data-id="element-53">
                    Fondator PROVI System
                  </p>
                </div>
              </div>
            </div>

            {/* Paragraph + CTA — third on mobile only */}
            <div className="order-3 lg:hidden text-center flex flex-col items-center" data-id="element-54">
              <p className="font-['Inter'] text-[19px] font-light text-[rgba(255,255,255,0.7)] leading-[1.8] mb-8 max-w-[600px]" data-id="element-55">
                Vin în compania ta, lucrez alături de tine și de echipa ta de
                lideri și implementez "PROVI System" pas cu pas, astfel încât
                afacerea ta să producă rezultate predictibile, să crească și să
                meargă fără implicarea ta zilnică.
              </p>

              <div className="flex flex-col items-center gap-4 mb-6 w-full" data-id="element-56">
                <a href="https://calendly.com/valerdura-coaching/sesiune-descoperire" className="font-['Montserrat'] text-[15px] font-semibold bg-[#1D4ED8] text-white px-8 py-4 rounded-xl shadow-[0_8px_24px_rgba(29,78,216,0.4)] hover:bg-[#2563EB] hover:-translate-y-1 transition-all duration-300 w-full sm:w-auto text-center inline-block no-underline" data-id="element-57">
                  Vreau o Diagnosticare Gratuită a Companiei
                </a>
              </div>

              <div className="flex items-start gap-3 max-w-[500px]" data-id="element-58">
                <svg className="w-5 h-5 text-[#3B82F6] flex-shrink-0 mt-0.5 opacity-70" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-59">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-60"></path>
                </svg>
                <p className="font-['Inter'] text-[15px] text-[rgba(255,255,255,0.6)] leading-[1.7]" data-id="element-61">
                  Dacă muncești la fel de mult ca acum 3 ani și afacerea tot nu
                  crește, problema nu ești tu. E lipsa sistemului.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 2 — PROBLEME / DURERI */}
      <section className="w-full bg-[#F1F5F9] py-14 md:py-20 relative" data-id="element-62">
        <div className="max-w-[1200px] mx-auto px-5 md:px-12 relative z-10" data-id="element-63">
          <div className="text-center max-w-[800px] mx-auto mb-16" data-id="element-64">
            <h2 className="font-['Montserrat'] text-[clamp(28px,4vw,40px)] font-bold text-[#09111F] mb-4 tracking-tight" data-id="element-65">
              Recunoști cel puțin una din aceste situații în compania ta?
            </h2>
            <div className="w-16 h-1 bg-[#1D4ED8] mx-auto rounded-full" data-id="element-66"></div>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-67">
            {/* Card 1 */}
            <div className="bg-white border border-[rgba(0,0,0,0.04)] border-l-4 border-l-[#1D4ED8] rounded-2xl p-8 relative overflow-hidden group hover:shadow-[0_12px_40px_rgba(0,0,0,0.06)] transition-all duration-300 hover:-translate-y-1" data-id="element-68">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-[#EFF6FF] to-transparent rounded-bl-full -z-10 opacity-50 group-hover:opacity-100 transition-opacity duration-300" data-id="element-69"></div>

              <div className="w-14 h-14 bg-[#EFF6FF] text-[#1D4ED8] rounded-xl flex items-center justify-center mb-6 shadow-sm group-hover:scale-110 transition-transform duration-300" data-id="element-70">
                <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-71">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-72"></path>
                </svg>
              </div>

              <div className="mb-5" data-id="element-73">
                <h3 className="font-['Montserrat'] text-[22px] font-bold text-[#09111F] mb-2" data-id="element-74">
                  CAPTIVITATE
                </h3>
                <div className="inline-block bg-[#F1F5F9] px-3 py-1 rounded-md" data-id="element-75">
                  <p className="font-['Montserrat'] text-[10px] font-bold tracking-[0.1em] uppercase text-[#6B7280]" data-id="element-76">
                    EPUIZARE · CONTROL · NON-STOP
                  </p>
                </div>
              </div>
              <p className="font-['Inter'] text-[19px] font-light text-[#4B5563] leading-[1.8]" data-id="element-77">
                Ești cel mai ocupat om din firmă ta. Faci vânzări, rezolvi
                probleme, iei decizii, gestionezi oameni și tot nu e suficient.
                Dacă pleci două săptămâni, totul se blochează. Ai construit o
                afacere care, în realitate, te deține pe tine.
              </p>
            </div>

            {/* Card 2 */}
            <div className="bg-white border border-[rgba(0,0,0,0.04)] border-l-4 border-l-[#3B82F6] rounded-2xl p-8 relative overflow-hidden group hover:shadow-[0_12px_40px_rgba(0,0,0,0.06)] transition-all duration-300 hover:-translate-y-1" data-id="element-78">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-[#EFF6FF] to-transparent rounded-bl-full -z-10 opacity-50 group-hover:opacity-100 transition-opacity duration-300" data-id="element-79"></div>

              <div className="w-14 h-14 bg-[#EFF6FF] text-[#3B82F6] rounded-xl flex items-center justify-center mb-6 shadow-sm group-hover:scale-110 transition-transform duration-300" data-id="element-80">
                <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-81">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" data-id="element-82"></path>
                </svg>
              </div>

              <div className="mb-5" data-id="element-83">
                <h3 className="font-['Montserrat'] text-[22px] font-bold text-[#09111F] mb-2" data-id="element-84">
                  PLAFONARE
                </h3>
                <div className="inline-block bg-[#F1F5F9] px-3 py-1 rounded-md" data-id="element-85">
                  <p className="font-['Montserrat'] text-[10px] font-bold tracking-[0.1em] uppercase text-[#6B7280]" data-id="element-86">
                    STAGNARE · FĂRĂ DIRECȚIE
                  </p>
                </div>
              </div>
              <p className="font-['Inter'] text-[19px] font-light text-[#4B5563] leading-[1.8]" data-id="element-87">
                Muncești la fel de mult ca acum câțiva ani, dar cifra nu mai
                crește. Echipa nu știe exact ce are de făcut fără tine. Nu
                există o viziune clară pe care toată lumea să o urmeze. Simți că
                dai în gol și nu înțelegi de ce.
              </p>
            </div>

            {/* Card 3 */}
            <div className="bg-white border border-[rgba(0,0,0,0.04)] border-l-4 border-l-[#0A1628] rounded-2xl p-8 relative overflow-hidden group hover:shadow-[0_12px_40px_rgba(0,0,0,0.06)] transition-all duration-300 hover:-translate-y-1" data-id="element-88">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-[#F1F5F9] to-transparent rounded-bl-full -z-10 opacity-50 group-hover:opacity-100 transition-opacity duration-300" data-id="element-89"></div>

              <div className="w-14 h-14 bg-[#F1F5F9] text-[#0A1628] rounded-xl flex items-center justify-center mb-6 shadow-sm group-hover:scale-110 transition-transform duration-300" data-id="element-90">
                <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-91">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" data-id="element-92"></path>
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 8l-4 4m0 0l-4-4m4 4v8" data-id="element-93"></path>
                </svg>
              </div>

              <div className="mb-5" data-id="element-94">
                <h3 className="font-['Montserrat'] text-[22px] font-bold text-[#09111F] mb-2" data-id="element-95">
                  HAOS
                </h3>
                <div className="inline-block bg-[#F1F5F9] px-3 py-1 rounded-md" data-id="element-96">
                  <p className="font-['Montserrat'] text-[10px] font-bold tracking-[0.1em] uppercase text-[#6B7280]" data-id="element-97">
                    IMPROVIZAȚIE · FĂRĂ PROCESE
                  </p>
                </div>
              </div>
              <p className="font-['Inter'] text-[19px] font-light text-[#4B5563] leading-[1.8]" data-id="element-98">
                Lucrurile se fac, dar nu se fac la fel de fiecare dată. Nu
                există procese clare, nu există roluri definite, nu există
                KPI-uri pe care echipa să le urmărească. Totul depinde de
                implicarea ta sau de cheful fiecărui angajat.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 3 — METODA / PROVI SYSTEM */}
      <section className="w-full bg-white py-14 md:py-20 overflow-hidden" data-id="element-99">
        <div className="max-w-[1200px] mx-auto px-5 md:px-12" data-id="element-100">
          <div className="text-center mb-16 md:mb-24" data-id="element-101">
            <h2 className="font-['Montserrat'] text-[clamp(28px,4vw,40px)] font-bold text-[#09111F] mb-6 tracking-tight" data-id="element-102">
              PROVI System: Cele 8 componente ale unei afaceri care merge fără
              tine
            </h2>
            <p className="font-['Inter'] text-[19px] font-light text-[#6B7280] leading-[1.8] max-w-[720px] mx-auto" data-id="element-103">
              Tocmai din acest motiv am construit sistemul unic de conducere
              antreprenorială construit să fie implementat pas cu pas, direct în
              compania ta, de o echipă de specialiști, până când afacerea ta
              funcționează singură.
            </p>
          </div>

          {/* Custom PROVI System Infographic */}
          <div className="relative w-full max-w-[700px] aspect-square md:aspect-[4/3] mx-auto mb-20 md:mb-28 overflow-visible" data-id="element-104">
            {/* Connecting Lines SVG */}
            <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet" data-id="element-105">
              <g stroke="#E5E7EB" strokeWidth="0.5" strokeDasharray="1 1" data-id="element-106">
                <line x1="50" y1="50" x2="50" y2="10" data-id="element-107" />
                <line x1="50" y1="50" x2="78" y2="22" data-id="element-108" />
                <line x1="50" y1="50" x2="90" y2="50" data-id="element-109" />
                <line x1="50" y1="50" x2="78" y2="78" data-id="element-110" />
                <line x1="50" y1="50" x2="50" y2="90" data-id="element-111" />
                <line x1="50" y1="50" x2="22" y2="78" data-id="element-112" />
                <line x1="50" y1="50" x2="10" y2="50" data-id="element-113" />
                <line x1="50" y1="50" x2="22" y2="22" data-id="element-114" />
              </g>
              <circle cx="50" cy="50" r="30" fill="none" stroke="#F3F4F6" strokeWidth="0.5" strokeDasharray="2 2" data-id="element-115" />
            </svg>

            {/* Center Hub */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-28 h-28 md:w-36 md:h-36 bg-gradient-to-br from-[#1D4ED8] to-[#0A1628] rounded-full flex flex-col items-center justify-center z-20 shadow-[0_0_40px_rgba(29,78,216,0.3)] border-4 border-white" data-id="element-116">
              <span className="font-['Montserrat'] text-white font-bold text-lg md:text-xl tracking-wider" data-id="element-117">
                PROVI
              </span>
              <span className="font-['Inter'] text-[#EFF6FF] text-[10px] md:text-xs uppercase tracking-[0.2em] opacity-80" data-id="element-118">
                System
              </span>
            </div>

            {/* The 8 Nodes with hover tooltips */}
            {[{
            label: 'Viziune',
            title: 'Viziune & Strategie',
            desc: 'Construim împreună direcția clară a companiei pe 1 până la 3 ani și planul concret care o face reală. Echipa ta va știi exact unde merge compania și de ce.',
            top: '10%',
            left: '50%',
            tooltipPos: 'top' as const,
            icon: 'M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z'
          }, {
            label: 'Oameni',
            title: 'Oameni & Roluri',
            desc: 'Definim organigrama funcțională, fișele de rol clare și matricea de responsabilități. Fiecare om din echipă știe ce are de făcut, față de cine răspunde și cum e măsurat.',
            top: '22%',
            left: '78%',
            tooltipPos: 'right' as const,
            icon: 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z'
          }, {
            label: 'Numere',
            title: 'Numere & KPI',
            desc: 'Instalăm un tablou de bord simplu, cu indicatorii care contează cu adevărat. Afacerea ta va fi condusă pe cifre reale, nu pe impresii sau după ureche.',
            top: '50%',
            left: '90%',
            tooltipPos: 'right' as const,
            icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z'
          }, {
            label: 'Procese',
            title: 'Procese & Execuție',
            desc: 'Documentăm procesele critice și implementăm sistemul de follow-up săptămânal. Orice angajat nou poate prelua un rol. Compania produce rezultate constant.',
            top: '78%',
            left: '78%',
            tooltipPos: 'right' as const,
            icon: 'M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15'
          }, {
            label: 'Probleme',
            title: 'Rezolvare Probleme',
            desc: 'Implementăm un sistem structurat de identificare și rezolvare a problemelor. Echipa învață să gândească în cauze, nu în simptome, și să rezolve definitiv.',
            top: '88%',
            left: '50%',
            tooltipPos: 'right' as const,
            icon: 'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z'
          }, {
            label: 'Progres',
            title: 'Progres & Follow-up',
            desc: 'Sesiuni săptămânale, lunare și trimestriale de măsurare a progresului. Fiecare obiectiv are un responsabil, un termen și un indicator clar de succes.',
            top: '78%',
            left: '22%',
            tooltipPos: 'left' as const,
            icon: 'M13 7h8m0 0v8m0-8l-8 8-4-4-6 6'
          }, {
            label: 'Cash',
            title: 'Cash & Financiar',
            desc: 'Construim tabloul financiar complet: cash-flow, marjă, profitabilitate pe servicii. Știi exact unde faci bani, unde pierzi și ce decizii trebuie să iei.',
            top: '50%',
            left: '10%',
            tooltipPos: 'left' as const,
            icon: 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
          }, {
            label: 'Mentalitate',
            title: 'Mentalitate & Leadership',
            desc: 'Lucrăm pe mentalitatea ta de fondator: de la „eu fac totul" la „eu conduc sistemul". Tranziția de la operator la arhitect al propriei companii.',
            top: '22%',
            left: '22%',
            tooltipPos: 'left' as const,
            icon: 'M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z'
          }].map((node, i) => {
            const invertedPos: Record<string, string> = {
              top: 'bottom',
              bottom: 'top',
              left: 'right',
              right: 'left'
            };
            const mobilePos = invertedPos[node.tooltipPos] || node.tooltipPos;
            const tooltipClasses: Record<string, string> = {
              top: 'bottom-full left-1/2 -translate-x-1/2 mb-3',
              bottom: 'top-full left-1/2 -translate-x-1/2 mt-3',
              left: 'right-full top-1/2 -translate-y-1/2 mr-3',
              right: 'left-full top-1/2 -translate-y-1/2 ml-3'
            };
            const arrowClasses: Record<string, string> = {
              top: 'top-full left-1/2 -translate-x-1/2 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[6px] border-t-white',
              bottom: 'bottom-full left-1/2 -translate-x-1/2 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-b-[6px] border-b-white',
              left: 'left-full top-1/2 -translate-y-1/2 border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent border-l-[6px] border-l-white',
              right: 'right-full top-1/2 -translate-y-1/2 border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent border-r-[6px] border-r-white'
            };
            const isActive = activeNode === i;
            return <div key={i} className="absolute w-20 h-20 md:w-24 md:h-24 bg-white border border-[#E5E7EB] rounded-full flex flex-col items-center justify-center z-10 shadow-[0_8px_20px_rgba(0,0,0,0.04)] hover:border-[#1D4ED8] hover:shadow-[0_8px_25px_rgba(29,78,216,0.15)] transition-all duration-300 group cursor-pointer" style={{
              top: node.top,
              left: node.left,
              transform: 'translate(-50%, -50%)'
            }} onClick={() => setActiveNode(isActive ? null : i)} data-id="element-119">
                  <svg className="w-6 h-6 text-[#6B7280] group-hover:text-[#1D4ED8] mb-1 transition-colors duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-120">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d={node.icon} data-id="element-121"></path>
                  </svg>
                  <span className="font-['Montserrat'] text-[10px] md:text-xs font-bold text-[#09111F]" data-id="element-122">
                    {node.label}
                  </span>

                  {/* Desktop tooltip — hover */}
                  <div className={`absolute ${tooltipClasses[node.tooltipPos]} w-[260px] bg-white rounded-xl shadow-[0_12px_40px_rgba(0,0,0,0.12)] border border-[#E5E7EB] p-4 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 pointer-events-none z-50 hidden md:block`} data-id="element-123">
                    <div className={`absolute ${arrowClasses[node.tooltipPos]}`} data-id="element-124"></div>
                    <p className="font-['Montserrat'] text-[14px] font-bold text-[#09111F] mb-2" data-id="element-125">
                      {node.title}
                    </p>
                    <p className="font-['Inter'] text-[13px] font-light text-[#4B5563] leading-[1.6]" data-id="element-126">
                      {node.desc}
                    </p>
                  </div>

                  {/* Mobile tooltip — click, inverted position */}
                  {isActive && <div className={`absolute ${tooltipClasses[mobilePos]} w-[220px] bg-white rounded-xl shadow-[0_12px_40px_rgba(0,0,0,0.15)] border border-[#1D4ED8] p-4 z-50 md:hidden`} data-id="element-127">
                      <div className={`absolute ${arrowClasses[mobilePos]}`} data-id="element-128"></div>
                      <p className="font-['Montserrat'] text-[13px] font-bold text-[#09111F] mb-2" data-id="element-129">
                        {node.title}
                      </p>
                      <p className="font-['Inter'] text-[12px] font-light text-[#4B5563] leading-[1.5]" data-id="element-130">
                        {node.desc}
                      </p>
                    </div>}
                </div>;
          })}
          </div>

          {/* 4 Piloni principali (Summary) */}
          <div className="grid md:grid-cols-2 gap-6 relative z-10" data-id="element-131">
            {/* Pilon 1 */}
            <div className="bg-white border border-[rgba(0,0,0,0.04)] rounded-2xl p-8 hover:shadow-lg transition-shadow duration-300" data-id="element-132">
              <div className="flex items-center gap-4 mb-5" data-id="element-133">
                <div className="w-12 h-12 bg-[#EFF6FF] rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-134">
                  <svg className="w-6 h-6 text-[#1D4ED8]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-135">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" data-id="element-136"></path>
                  </svg>
                </div>
                <h3 className="font-['Montserrat'] text-[20px] font-bold text-[#09111F]" data-id="element-137">
                  Viziune & Strategie
                </h3>
              </div>
              <p className="font-['Inter'] text-[19px] font-light text-[#4B5563] leading-[1.8]" data-id="element-138">
                Construim împreună direcția clară a companiei pe 1 până la 3 ani
                și planul concret care o face reală. Echipa ta va știi exact
                unde merge compania și de ce.
              </p>
            </div>

            {/* Pilon 2 */}
            <div className="bg-white border border-[rgba(0,0,0,0.04)] rounded-2xl p-8 hover:shadow-lg transition-shadow duration-300" data-id="element-139">
              <div className="flex items-center gap-4 mb-5" data-id="element-140">
                <div className="w-12 h-12 bg-[#EFF6FF] rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-141">
                  <svg className="w-6 h-6 text-[#1D4ED8]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-142">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" data-id="element-143"></path>
                  </svg>
                </div>
                <h3 className="font-['Montserrat'] text-[20px] font-bold text-[#09111F]" data-id="element-144">
                  Oameni & Roluri
                </h3>
              </div>
              <p className="font-['Inter'] text-[19px] font-light text-[#4B5563] leading-[1.8]" data-id="element-145">
                Definim organigrama funcțională, fișele de rol clare și matricea
                de responsabilități. Fiecare om din echipă știe ce are de făcut,
                față de cine răspunde și cum e măsurat.
              </p>
            </div>

            {/* Pilon 3 */}
            <div className="bg-white border border-[rgba(0,0,0,0.04)] rounded-2xl p-8 hover:shadow-lg transition-shadow duration-300" data-id="element-146">
              <div className="flex items-center gap-4 mb-5" data-id="element-147">
                <div className="w-12 h-12 bg-[#EFF6FF] rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-148">
                  <svg className="w-6 h-6 text-[#1D4ED8]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-149">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" data-id="element-150"></path>
                  </svg>
                </div>
                <h3 className="font-['Montserrat'] text-[20px] font-bold text-[#09111F]" data-id="element-151">
                  Numere & KPI
                </h3>
              </div>
              <p className="font-['Inter'] text-[19px] font-light text-[#4B5563] leading-[1.8]" data-id="element-152">
                Instalăm un tablou de bord simplu, cu indicatorii care contează
                cu adevărat. Afacerea ta va fi condusă pe cifre reale, nu pe
                impresii sau după ureche.
              </p>
            </div>

            {/* Pilon 4 */}
            <div className="bg-white border border-[rgba(0,0,0,0.04)] rounded-2xl p-8 hover:shadow-lg transition-shadow duration-300" data-id="element-153">
              <div className="flex items-center gap-4 mb-5" data-id="element-154">
                <div className="w-12 h-12 bg-[#EFF6FF] rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-155">
                  <svg className="w-6 h-6 text-[#1D4ED8]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-156">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" data-id="element-157"></path>
                  </svg>
                </div>
                <h3 className="font-['Montserrat'] text-[20px] font-bold text-[#09111F]" data-id="element-158">
                  Procese & Progres
                </h3>
              </div>
              <p className="font-['Inter'] text-[19px] font-light text-[#4B5563] leading-[1.8]" data-id="element-159">
                Documentăm procesele critice și implementăm sistemul de
                follow-up săptămânal. Orice angajat nou poate prelua un rol.
                Compania produce rezultate constant, nu doar când ești tu
                prezent.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 4 — DESPRE MINE */}
      <section className="w-full bg-[#0A1628] py-14 md:py-20 relative overflow-hidden" data-id="element-160">
        {/* Dark section background pattern */}
        <div className="absolute inset-0 opacity-[0.02] bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-161"></div>
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-gradient-to-bl from-[rgba(29,78,216,0.1)] to-transparent rounded-full blur-[100px] pointer-events-none" data-id="element-162"></div>

        <div className="max-w-[1200px] mx-auto px-5 md:px-12 relative z-10" data-id="element-163">
          <div className="grid md:grid-cols-[500px_1fr] gap-10 md:gap-14 items-stretch" data-id="element-164">
            {/* LEFT — Photo with decorative elements */}
            <div className="relative w-full max-w-[500px] mx-auto self-stretch" data-id="element-165">
              {/* Top-left: dot grid */}
              <svg className="absolute -top-10 -left-10 w-32 h-32 text-[#1D4ED8] opacity-50 z-0" fill="currentColor" viewBox="0 0 100 100" data-id="element-166">
                <pattern id="aboutDots" x="0" y="0" width="16" height="16" patternUnits="userSpaceOnUse" data-id="element-167">
                  <circle cx="2" cy="2" r="2" data-id="element-168" />
                </pattern>
                <rect width="100" height="100" fill="url(#aboutDots)" data-id="element-169" />
              </svg>

              {/* Corner accents */}
              <div className="absolute -top-6 -right-6 z-0" data-id="element-170">
                <div className="w-20 h-20 border-t-[3px] border-r-[3px] border-[rgba(59,130,246,0.5)] rounded-tr-2xl" data-id="element-171"></div>
              </div>
              <div className="absolute -bottom-6 -left-6 z-0" data-id="element-172">
                <div className="w-20 h-20 border-b-[3px] border-l-[3px] border-[rgba(59,130,246,0.5)] rounded-bl-2xl" data-id="element-173"></div>
              </div>

              {/* Glows */}
              <div className="absolute -bottom-10 -right-10 w-40 h-40 bg-[#1D4ED8] opacity-25 rounded-full blur-[50px] z-0" data-id="element-174"></div>
              <div className="absolute -top-8 -left-8 w-32 h-32 bg-[#3B82F6] opacity-15 rounded-full blur-[40px] z-0" data-id="element-175"></div>

              {/* Badge top-right */}
              <div className="absolute -top-4 right-4 z-30 bg-[#1D4ED8] px-4 py-2.5 rounded-xl shadow-[0_8px_24px_rgba(29,78,216,0.5)]" data-id="element-176">
                <span className="font-['Montserrat'] text-white text-[11px] font-bold tracking-wider leading-tight block text-center" data-id="element-177">
                  32+ ANI DE EXPERIENȚĂ
                  <br data-id="element-178" />
                  ÎN ANTREPRENORIAT
                </span>
              </div>

              {/* Badge bottom-left */}
              <div className="absolute -bottom-4 left-4 z-30 bg-[rgba(255,255,255,0.08)] backdrop-blur-xl border border-[rgba(255,255,255,0.15)] px-4 py-2.5 rounded-xl" data-id="element-179">
                <span className="font-['Montserrat'] text-white text-[12px] font-bold tracking-wide" data-id="element-180">
                  PROVI System
                </span>
              </div>

              {/* Main Image — full height */}
              <div className="relative z-10 rounded-2xl overflow-hidden border-2 border-[rgba(255,255,255,0.1)] shadow-[0_20px_60px_rgba(0,0,0,0.5)] h-full min-h-[500px]" data-id="element-181">
                <img src="https://cdn.magicpatterns.com/uploads/iBEbtRXUbrUYaPC1MiruXn/Valer_tabala.jpg" alt="Valer Dura — Workshop cu antreprenori" className="w-full h-full object-cover object-[70%_20%]" data-id="element-182" />
              </div>

              {/* Decorative rings */}
              <div className="absolute -bottom-5 -right-5 w-16 h-16 border-2 border-[rgba(59,130,246,0.4)] rounded-full z-0" data-id="element-183"></div>
              <div className="absolute -bottom-2 -right-2 w-10 h-10 border-2 border-[rgba(59,130,246,0.25)] rounded-full z-0" data-id="element-184"></div>
            </div>

            {/* RIGHT — All Text + Mission */}
            <div className="relative flex flex-col justify-center" data-id="element-185">
              <div className="inline-flex items-center gap-2 bg-[rgba(29,78,216,0.1)] border border-[rgba(29,78,216,0.2)] backdrop-blur-md px-4 py-2 rounded-full mb-6 w-fit" data-id="element-186">
                <span className="font-['Montserrat'] text-[11px] font-bold tracking-[0.18em] uppercase text-[#3B82F6]" data-id="element-187">
                  DESPRE MINE
                </span>
              </div>

              <h2 className="font-['Montserrat'] text-[clamp(32px,4vw,44px)] font-bold text-white mb-3 tracking-tight" data-id="element-188">
                Valer Dura
              </h2>

              <p className="font-['Montserrat'] text-[16px] font-semibold text-[#3B82F6] mb-6" data-id="element-189">
                Arhitect de Sisteme Antreprenoriale Scalabile & Vandabile
              </p>

              <div className="space-y-4 font-['Inter'] text-[19px] font-light text-[rgba(255,255,255,0.75)] leading-[1.8] mb-10" data-id="element-190">
                <p data-id="element-191">
                  Sunt Valer Dura și lucrez cu antreprenori mici și mijlocii
                  care au construit o afacere ce funcționează, dar nu
                  funcționează fără ei. Am 32 de ani de experiență în
                  implementarea sistemelor de conducere pentru companii
                  românești, am construit și vândut afaceri cu cifre de milioane
                  de euro și știu din interior cum arată o companie care ajunge
                  la nivelul la care fondatorul are libertate, timp și bani.
                </p>
                <p data-id="element-192">
                  Prin PROVI System, implementez în compania ta cele 8
                  componente esențiale ale unui business sistematizat: de la
                  viziune și structură de echipă, la KPI-uri, procese, follow-up
                  săptămânal și management financiar. Nu predau teorie. Vin cu
                  echipa mea de implementatori, lucrăm direct cu liderii tăi și
                  construim sistemul de la zero până la funcțional.
                </p>
                <p className="text-white font-medium" data-id="element-193">
                  Rezultatul nu e un dosar cu recomandări. E o companie care
                  produce rezultate fără ca tu să fii prezent în fiecare zi.
                </p>
              </div>

              {/* Misiunea mea — inside right column */}
              <div className="bg-[rgba(255,255,255,0.03)] border border-[rgba(255,255,255,0.06)] backdrop-blur-xl rounded-2xl p-6" data-id="element-194">
                <div className="flex items-center gap-3 mb-5" data-id="element-195">
                  <div className="w-10 h-10 bg-[rgba(59,130,246,0.1)] rounded-lg flex items-center justify-center" data-id="element-196">
                    <svg className="w-5 h-5 text-[#3B82F6]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-197">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" data-id="element-198"></path>
                    </svg>
                  </div>
                  <h3 className="font-['Montserrat'] text-[20px] font-bold text-white" data-id="element-199">
                    Misiunea mea
                  </h3>
                </div>

                <div className="space-y-3" data-id="element-200">
                  <div className="flex items-start gap-3 bg-[rgba(255,255,255,0.02)] border border-[rgba(255,255,255,0.04)] rounded-xl p-4" data-id="element-201">
                    <div className="w-6 h-6 rounded-full bg-[rgba(29,78,216,0.25)] border border-[rgba(29,78,216,0.5)] flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-202">
                      <div className="w-2 h-2 bg-[#3B82F6] rounded-full" data-id="element-203"></div>
                    </div>
                    <p className="font-['Inter'] text-[17px] font-light text-[rgba(255,255,255,0.8)] leading-[1.6]" data-id="element-204">
                      Din antreprenor captiv în propria firmă, la{' '}
                      <strong className="text-white font-medium" data-id="element-205">
                        fondator liber
                      </strong>
                      .
                    </p>
                  </div>

                  <div className="flex items-start gap-3 bg-[rgba(255,255,255,0.02)] border border-[rgba(255,255,255,0.04)] rounded-xl p-4" data-id="element-206">
                    <div className="w-6 h-6 rounded-full bg-[rgba(29,78,216,0.25)] border border-[rgba(29,78,216,0.5)] flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-207">
                      <div className="w-2 h-2 bg-[#3B82F6] rounded-full" data-id="element-208"></div>
                    </div>
                    <p className="font-['Inter'] text-[17px] font-light text-[rgba(255,255,255,0.8)] leading-[1.6]" data-id="element-209">
                      Din companie dependentă de om, la{' '}
                      <strong className="text-white font-medium" data-id="element-210">
                        sistem care funcționează singur
                      </strong>
                      .
                    </p>
                  </div>

                  <div className="flex items-start gap-3 bg-[rgba(255,255,255,0.02)] border border-[rgba(255,255,255,0.04)] rounded-xl p-4" data-id="element-211">
                    <div className="w-6 h-6 rounded-full bg-[rgba(29,78,216,0.25)] border border-[rgba(29,78,216,0.5)] flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-212">
                      <div className="w-2 h-2 bg-[#3B82F6] rounded-full" data-id="element-213"></div>
                    </div>
                    <p className="font-['Inter'] text-[17px] font-light text-[rgba(255,255,255,0.8)] leading-[1.6]" data-id="element-214">
                      Din stagnare și plafonare, la{' '}
                      <strong className="text-white font-medium" data-id="element-215">
                        creștere predictibilă și garantată
                      </strong>
                      .
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 5 — MODALITĂȚI DE A LUCRA CU MINE */}
      <section className="w-full bg-[#F1F5F9] py-14 md:py-20 relative z-10" data-id="element-216">
        <div className="absolute top-0 left-0 w-full h-64 bg-gradient-to-b from-white to-transparent opacity-50" data-id="element-217"></div>

        <div className="max-w-[1200px] mx-auto px-5 md:px-12 relative z-10" data-id="element-218">
          <div className="text-center max-w-[700px] mx-auto mb-16" data-id="element-219">
            <h2 className="font-['Montserrat'] text-[clamp(28px,4vw,40px)] font-bold text-[#09111F] mb-4 tracking-tight" data-id="element-220">
              Implementare PROVI System
            </h2>
            <p className="font-['Inter'] text-[19px] font-light text-[#6B7280] leading-[1.8]" data-id="element-221">
              Vin în compania ta și construim totul împreună.
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-8" data-id="element-222">
            {/* Oferta 1 - Diagnostic */}
            <div className="bg-white border border-[rgba(0,0,0,0.06)] rounded-3xl p-8 hover:shadow-[0_12px_30px_rgba(0,0,0,0.06)] transition-all duration-300 text-center" data-id="element-223">
              <div className="w-14 h-14 bg-[#EFF6FF] rounded-2xl flex items-center justify-center mb-6 mx-auto" data-id="element-224">
                <svg className="w-7 h-7 text-[#1D4ED8]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-225">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" data-id="element-226"></path>
                </svg>
              </div>

              <h3 className="font-['Montserrat'] text-[22px] font-bold text-[#09111F] mb-2" data-id="element-227">
                Diagnostic PROVI
              </h3>
              <p className="font-['Inter'] text-[19px] text-[#6B7280] mb-8" data-id="element-228">
                Evaluare personalizată a companiei tale, 1 la 1
              </p>

              <ul className="space-y-4 mb-8" data-id="element-229">
                {['Analizăm împreună toate departamentele companiei tale', 'Identificăm blocajele reale care te țin pe loc acum', 'Primești harta exactă a priorităților de implementare', 'Înțelegi ce anume oprește creșterea, în termeni clari, fără jargon', 'Primul pas înainte de orice implementare'].map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-230">
                    <div className="w-5 h-5 rounded-full bg-[#EFF6FF] flex items-center justify-center flex-shrink-0 mt-1" data-id="element-231">
                      <svg className="w-3 h-3 text-[#1D4ED8]" fill="currentColor" viewBox="0 0 20 20" data-id="element-232">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-233" />
                      </svg>
                    </div>
                    <span className="font-['Inter'] text-[19px] font-light text-[#4B5563] leading-[1.6]" data-id="element-234">
                      {text}
                    </span>
                  </li>)}
              </ul>

              <a href="https://calendly.com/valerdura-coaching/sesiune-descoperire" className="block w-full font-['Montserrat'] text-[15px] font-bold bg-[#1D4ED8] text-white px-6 py-4 rounded-xl shadow-[0_8px_20px_rgba(29,78,216,0.3)] hover:bg-[#2563EB] hover:-translate-y-0.5 transition-all duration-300 text-center no-underline" data-id="element-235">
                Vreau Diagnosticarea Companiei
              </a>
            </div>

            {/* Oferta 2 - PROVI System (Principal, în mijloc) */}
            <div className="bg-white border-2 border-[#1D4ED8] rounded-3xl p-8 relative shadow-[0_20px_40px_rgba(29,78,216,0.08)] transform lg:-translate-y-4 text-center" data-id="element-236">
              <div className="absolute -top-4 inset-x-0 flex justify-center" data-id="element-237">
                <span className="bg-[#1D4ED8] text-white font-['Montserrat'] text-[10px] font-bold tracking-[0.15em] uppercase px-4 py-1.5 rounded-full shadow-md" data-id="element-238">
                  ★ CEL MAI RECOMANDAT
                </span>
              </div>

              <div className="w-14 h-14 bg-[#EFF6FF] rounded-2xl flex items-center justify-center mb-6 mt-2 mx-auto" data-id="element-239">
                <svg className="w-7 h-7 text-[#1D4ED8]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-240">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" data-id="element-241"></path>
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" data-id="element-242"></path>
                </svg>
              </div>

              <h3 className="font-['Montserrat'] text-[24px] font-bold text-[#09111F] mb-2" data-id="element-243">
                Implementare PROVI System
              </h3>
              <p className="font-['Inter'] text-[19px] text-[#6B7280] mb-8" data-id="element-244">
                Vin în compania ta și construim totul împreună
              </p>

              <ul className="space-y-4 mb-8" data-id="element-245">
                {['Implementare completă a celor 8 componente PROVI, pas cu pas', 'Lucrez direct cu tine și cu echipa ta de lideri, nu predau teorie', 'Echipă de specialiști pe departamente: financiar, HR, procese, automatizare', 'Sesiuni săptămânale, lunare și trimestriale de progres și corecție', 'La final, compania ta funcționează predictibil, cu sau fără tine'].map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-246">
                    <div className="w-5 h-5 rounded-full bg-[#EFF6FF] flex items-center justify-center flex-shrink-0 mt-1" data-id="element-247">
                      <svg className="w-3 h-3 text-[#1D4ED8]" fill="currentColor" viewBox="0 0 20 20" data-id="element-248">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-249" />
                      </svg>
                    </div>
                    <span className="font-['Inter'] text-[19px] font-light text-[#4B5563] leading-[1.6]" data-id="element-250">
                      {text}
                    </span>
                  </li>)}
              </ul>

              <a href="https://calendly.com/valerdura-coaching/sesiune-descoperire" className="block w-full font-['Montserrat'] text-[15px] font-bold bg-[#1D4ED8] text-white px-6 py-4 rounded-xl shadow-[0_8px_20px_rgba(29,78,216,0.3)] hover:bg-[#2563EB] hover:-translate-y-0.5 transition-all duration-300 text-center no-underline" data-id="element-251">
                Vreau să Implementăm PROVI
              </a>
            </div>

            {/* Oferta 3 - Workshop */}
            <div className="bg-white border border-[rgba(0,0,0,0.06)] rounded-3xl p-8 hover:shadow-[0_12px_30px_rgba(0,0,0,0.06)] transition-all duration-300 text-center" data-id="element-252">
              <div className="w-14 h-14 bg-[#EFF6FF] rounded-2xl flex items-center justify-center mb-6 mx-auto" data-id="element-253">
                <svg className="w-7 h-7 text-[#1D4ED8]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-254">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" data-id="element-255"></path>
                </svg>
              </div>

              <h3 className="font-['Montserrat'] text-[22px] font-bold text-[#09111F] mb-2" data-id="element-256">
                Workshop Intensiv
              </h3>
              <p className="font-['Inter'] text-[19px] text-[#6B7280] mb-8" data-id="element-257">
                2 zile de lucru concret cu echipa ta
              </p>

              <ul className="space-y-4 mb-8" data-id="element-258">
                {['Lucrăm intensiv pe un blocaj specific sau pe strategia anuală', 'Antreprenor plus echipă de lideri, în același timp, în aceeași sală', 'Ieși cu planul clar, asumat și gata de implementat', 'Format concentrat, fără timp pierdut, cu rezultat concret la final', 'Potrivit când ai nevoie de claritate rapid, nu de implementare lungă'].map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-259">
                    <div className="w-5 h-5 rounded-full bg-[#EFF6FF] flex items-center justify-center flex-shrink-0 mt-1" data-id="element-260">
                      <svg className="w-3 h-3 text-[#1D4ED8]" fill="currentColor" viewBox="0 0 20 20" data-id="element-261">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-262" />
                      </svg>
                    </div>
                    <span className="font-['Inter'] text-[19px] font-light text-[#4B5563] leading-[1.6]" data-id="element-263">
                      {text}
                    </span>
                  </li>)}
              </ul>

              <a href="https://calendly.com/valerdura-coaching/sesiune-descoperire" className="block w-full font-['Montserrat'] text-[15px] font-bold bg-[#1D4ED8] text-white px-6 py-4 rounded-xl shadow-[0_8px_20px_rgba(29,78,216,0.3)] hover:bg-[#2563EB] hover:-translate-y-0.5 transition-all duration-300 text-center no-underline" data-id="element-264">
                Vreau un Workshop Intensiv
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 6 — DIAGNOSTIC CADOU */}
      <section className="w-full bg-[#09111F] py-16 md:py-24 relative overflow-hidden" data-id="element-265">
        {/* Glowing Background Effects */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[500px] bg-[#1D4ED8] opacity-15 blur-[150px] rounded-[100%] pointer-events-none" data-id="element-266"></div>
        <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:30px_30px]" data-id="element-267"></div>

        {/* Decorative corner elements */}
        <div className="absolute top-12 left-12 w-24 h-24 border-t-2 border-l-2 border-[rgba(59,130,246,0.15)] rounded-tl-3xl pointer-events-none" data-id="element-268"></div>
        <div className="absolute bottom-12 right-12 w-24 h-24 border-b-2 border-r-2 border-[rgba(59,130,246,0.15)] rounded-br-3xl pointer-events-none" data-id="element-269"></div>

        <div className="max-w-[1200px] mx-auto px-5 md:px-12 relative z-10" data-id="element-270">
          <div className="grid md:grid-cols-[380px_1fr] gap-12 md:gap-16 items-center" data-id="element-271">
            {/* Left — Valer Photo (tall/portrait) */}
            <div className="relative hidden md:block" data-id="element-272">
              {/* Decorative frame */}
              <div className="absolute -top-4 -left-4 w-full h-full border-2 border-[rgba(29,78,216,0.2)] rounded-2xl pointer-events-none" data-id="element-273"></div>
              <div className="absolute -bottom-4 -right-4 w-full h-full border-2 border-[rgba(29,78,216,0.1)] rounded-2xl pointer-events-none" data-id="element-274"></div>

              {/* Blue accent corner */}
              <div className="absolute -top-2 -left-2 w-8 h-8 border-t-3 border-l-3 border-[#1D4ED8] rounded-tl-lg pointer-events-none" data-id="element-275"></div>
              <div className="absolute -bottom-2 -right-2 w-8 h-8 border-b-3 border-r-3 border-[#1D4ED8] rounded-br-lg pointer-events-none" data-id="element-276"></div>

              <img src="https://cdn.magicpatterns.com/uploads/3TMjjGSbVzhxhochReypN4/Valer_alb_negru.jpg" alt="Valer Dura — Sesiune de Diagnoză" className="w-full h-[520px] object-cover object-top rounded-2xl relative z-10" data-id="element-277" />

              {/* Floating badge */}
              <div className="absolute -right-6 bottom-12 z-20 bg-[#1D4ED8] text-white px-5 py-3 rounded-xl shadow-[0_8px_24px_rgba(29,78,216,0.4)]" data-id="element-278">
                <p className="font-['Montserrat'] text-[11px] font-bold tracking-[0.1em] uppercase" data-id="element-279">
                  100% CADOU
                </p>
              </div>
            </div>

            {/* Right — Text content + Stats */}
            <div data-id="element-280">
              <div className="inline-flex items-center gap-2 bg-[rgba(29,78,216,0.15)] border border-[rgba(29,78,216,0.3)] px-4 py-2 rounded-full mb-8" data-id="element-281">
                <div className="w-2 h-2 rounded-full bg-[#3B82F6] animate-pulse" data-id="element-282"></div>
                <span className="font-['Montserrat'] text-[11px] font-bold tracking-[0.18em] uppercase text-[#3B82F6]" data-id="element-283">
                  SESIUNE CADOU DE DIAGNOZĂ
                </span>
              </div>

              <h2 className="font-['Montserrat'] text-[clamp(24px,3.5vw,36px)] font-bold text-white mb-6 tracking-tight leading-[1.15]" data-id="element-284">
                Află în 60 de minute ce oprește creșterea companiei tale
              </h2>

              <p className="font-['Inter'] text-[19px] font-light text-[rgba(255,255,255,0.75)] leading-[1.8] mb-10" data-id="element-285">
                Rezervă o sesiune de diagnostic CADOU cu mine. Analizăm împreună
                situația reală a afacerii tale și îți spun exact ce lipsește, în
                ce ordine trebuie rezolvat și cum arată primul pas concret spre
                o companie care merge fără tine.
              </p>

              <a href="https://calendly.com/valerdura-coaching/sesiune-descoperire" className="inline-block font-['Montserrat'] text-[15px] font-bold bg-[#1D4ED8] text-white px-10 py-5 rounded-xl shadow-[0_8px_24px_rgba(29,78,216,0.4)] hover:bg-[#2563EB] hover:-translate-y-1 transition-all duration-300 mb-12 no-underline" data-id="element-286">
                Rezervă Sesiunea de Diagnoză Cadou
              </a>

              {/* Stat cards — horizontal row */}
              <div className="grid grid-cols-3 gap-4" data-id="element-287">
                {/* 60 minute */}
                <div className="bg-[rgba(255,255,255,0.04)] border border-[rgba(255,255,255,0.08)] backdrop-blur-xl rounded-2xl p-5 text-center hover:bg-[rgba(255,255,255,0.06)] transition-colors duration-300" data-id="element-288">
                  <p className="font-['Montserrat'] text-[36px] font-bold text-white leading-none mb-1" data-id="element-289">
                    60
                  </p>
                  <p className="font-['Montserrat'] text-[12px] font-bold tracking-[0.15em] uppercase text-[#3B82F6] mb-3" data-id="element-290">
                    minute
                  </p>
                  <p className="font-['Inter'] text-[13px] text-[rgba(255,255,255,0.45)] leading-[1.5]" data-id="element-291">
                    Sesiune 1-la-1 cu Valer Dura, focusată pe compania ta
                  </p>
                </div>

                {/* 8 arii */}
                <div className="bg-[rgba(255,255,255,0.04)] border border-[rgba(255,255,255,0.08)] backdrop-blur-xl rounded-2xl p-5 text-center hover:bg-[rgba(255,255,255,0.06)] transition-colors duration-300" data-id="element-292">
                  <p className="font-['Montserrat'] text-[36px] font-bold text-white leading-none mb-1" data-id="element-293">
                    8
                  </p>
                  <p className="font-['Montserrat'] text-[12px] font-bold tracking-[0.15em] uppercase text-[#3B82F6] mb-3" data-id="element-294">
                    arii analizate
                  </p>
                  <p className="font-['Inter'] text-[13px] text-[rgba(255,255,255,0.45)] leading-[1.5]" data-id="element-295">
                    Evaluare completă pe toate cele 8 componente PROVI
                  </p>
                </div>

                {/* 0€ */}
                <div className="bg-[rgba(255,255,255,0.04)] border border-[rgba(255,255,255,0.08)] backdrop-blur-xl rounded-2xl p-5 text-center hover:bg-[rgba(255,255,255,0.06)] transition-colors duration-300" data-id="element-296">
                  <p className="font-['Montserrat'] text-[36px] font-bold text-white leading-none mb-1" data-id="element-297">
                    0 €
                  </p>
                  <p className="font-['Montserrat'] text-[12px] font-bold tracking-[0.15em] uppercase text-[#3B82F6] mb-3" data-id="element-298">
                    cost
                  </p>
                  <p className="font-['Inter'] text-[13px] text-[rgba(255,255,255,0.45)] leading-[1.5]" data-id="element-299">
                    Sesiune gratuită, fără obligații ulterioare
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 7 — TESTIMONIALE */}
      <section className="w-full bg-[#F1F5F9] py-14 md:py-20 relative" data-id="element-300">
        <div className="max-w-[1200px] mx-auto px-5 md:px-12 relative z-10" data-id="element-301">
          <div className="text-center max-w-[800px] mx-auto mb-16" data-id="element-302">
            <h2 className="font-['Montserrat'] text-[clamp(28px,4vw,40px)] font-bold text-[#09111F] mb-4 tracking-tight" data-id="element-303">
              Ce spun antreprenorii care au implementat PROVI System
            </h2>
            <div className="w-16 h-1 bg-[#1D4ED8] mx-auto rounded-full" data-id="element-304"></div>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-305">
            {/* Testimonial 1 — Radu N. */}
            <div className="bg-white border border-[rgba(0,0,0,0.04)] rounded-3xl p-8 relative hover:shadow-[0_12px_30px_rgba(0,0,0,0.04)] transition-shadow duration-300" data-id="element-306">
              <div className="absolute top-6 right-8 text-[#F1F5F9]" data-id="element-307">
                <svg className="w-16 h-16" fill="currentColor" viewBox="0 0 24 24" data-id="element-308">
                  <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" data-id="element-309" />
                </svg>
              </div>
              <div className="relative z-10" data-id="element-310">
                <div className="flex gap-1 mb-6 text-[#F59E0B]" data-id="element-311">
                  {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" data-id="element-312">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-313" />
                    </svg>)}
                </div>
                <p className="font-['Inter'] text-[19px] font-light text-[#4B5563] leading-[1.8] mb-8 italic" data-id="element-314">
                  "Aveam 47 de angajați și totuși mă sunam cineva pentru fiecare
                  decizie. După 6 luni cu Valer, am plecat 3 săptămâni în
                  vacanță și cifra de afaceri a crescut cu 12%. Nu exagerez —
                  pur și simplu sistemul funcționează."
                </p>
                <div className="flex items-center gap-4 border-t border-[rgba(0,0,0,0.06)] pt-6" data-id="element-315">
                  <div className="w-12 h-12 bg-[#EFF6FF] rounded-full flex items-center justify-center text-[#1D4ED8] font-['Montserrat'] font-bold text-[14px]" data-id="element-316">
                    RN
                  </div>
                  <div data-id="element-317">
                    <p className="font-['Montserrat'] text-[15px] font-bold text-[#09111F]" data-id="element-318">
                      Radu N.
                    </p>
                    <p className="font-['Inter'] text-[13px] text-[#6B7280]" data-id="element-319">
                      Antreprenor — Distribuție & Logistică
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Testimonial 2 — Ioana C. */}
            <div className="bg-white border border-[rgba(0,0,0,0.04)] rounded-3xl p-8 relative hover:shadow-[0_12px_30px_rgba(0,0,0,0.04)] transition-shadow duration-300" data-id="element-320">
              <div className="absolute top-6 right-8 text-[#F1F5F9]" data-id="element-321">
                <svg className="w-16 h-16" fill="currentColor" viewBox="0 0 24 24" data-id="element-322">
                  <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" data-id="element-323" />
                </svg>
              </div>
              <div className="relative z-10" data-id="element-324">
                <div className="flex gap-1 mb-6 text-[#F59E0B]" data-id="element-325">
                  {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" data-id="element-326">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-327" />
                    </svg>)}
                </div>
                <p className="font-['Inter'] text-[19px] font-light text-[#4B5563] leading-[1.8] mb-8 italic" data-id="element-328">
                  "Credeam că problema e că nu găsesc oameni buni. Valer mi-a
                  arătat că problema era că nu aveam procese clare pe care
                  oamenii să le urmeze. Am restructurat totul în 4 luni și acum
                  echipa livrează constant fără mine în spate."
                </p>
                <div className="flex items-center gap-4 border-t border-[rgba(0,0,0,0.06)] pt-6" data-id="element-329">
                  <div className="w-12 h-12 bg-[#EFF6FF] rounded-full flex items-center justify-center text-[#1D4ED8] font-['Montserrat'] font-bold text-[14px]" data-id="element-330">
                    IC
                  </div>
                  <div data-id="element-331">
                    <p className="font-['Montserrat'] text-[15px] font-bold text-[#09111F]" data-id="element-332">
                      Ioana C.
                    </p>
                    <p className="font-['Inter'] text-[13px] text-[#6B7280]" data-id="element-333">
                      Antreprenor — Servicii IT & Software
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Testimonial 3 — Vlad T. */}
            <div className="bg-white border border-[rgba(0,0,0,0.04)] rounded-3xl p-8 relative hover:shadow-[0_12px_30px_rgba(0,0,0,0.04)] transition-shadow duration-300" data-id="element-334">
              <div className="absolute top-6 right-8 text-[#F1F5F9]" data-id="element-335">
                <svg className="w-16 h-16" fill="currentColor" viewBox="0 0 24 24" data-id="element-336">
                  <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" data-id="element-337" />
                </svg>
              </div>
              <div className="relative z-10" data-id="element-338">
                <div className="flex gap-1 mb-6 text-[#F59E0B]" data-id="element-339">
                  {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" data-id="element-340">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-341" />
                    </svg>)}
                </div>
                <p className="font-['Inter'] text-[19px] font-light text-[#4B5563] leading-[1.8] mb-8 italic" data-id="element-342">
                  "Am vândut compania la 2 ani după ce am terminat implementarea
                  cu Valer. Cumpărătorul a spus că l-a convins faptul că totul
                  era documentat și funcționa independent de mine. Fără PROVI
                  System, nu cred că aș fi reușit."
                </p>
                <div className="flex items-center gap-4 border-t border-[rgba(0,0,0,0.06)] pt-6" data-id="element-343">
                  <div className="w-12 h-12 bg-[#EFF6FF] rounded-full flex items-center justify-center text-[#1D4ED8] font-['Montserrat'] font-bold text-[14px]" data-id="element-344">
                    VT
                  </div>
                  <div data-id="element-345">
                    <p className="font-['Montserrat'] text-[15px] font-bold text-[#09111F]" data-id="element-346">
                      Vlad T.
                    </p>
                    <p className="font-['Inter'] text-[13px] text-[#6B7280]" data-id="element-347">
                      Antreprenor — Producție & Manufacturing
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 8 — FOOTER CTA */}
      <section className="w-full bg-[#0A1628] py-16 md:py-24 relative overflow-hidden" data-id="element-348">
        {/* Dramatic background effects */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#1D4ED8] opacity-[0.08] blur-[200px] rounded-full pointer-events-none" data-id="element-349"></div>
        <div className="absolute top-0 left-0 w-[400px] h-[400px] bg-[#3B82F6] opacity-[0.05] blur-[120px] rounded-full pointer-events-none" data-id="element-350"></div>
        <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-[#1D4ED8] opacity-[0.05] blur-[120px] rounded-full pointer-events-none" data-id="element-351"></div>
        <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:24px_24px]" data-id="element-352"></div>

        {/* Decorative corner accents */}
        <div className="absolute top-8 left-8 w-32 h-32 border-t-2 border-l-2 border-[rgba(59,130,246,0.2)] rounded-tl-3xl pointer-events-none" data-id="element-353"></div>
        <div className="absolute bottom-8 right-8 w-32 h-32 border-b-2 border-r-2 border-[rgba(59,130,246,0.2)] rounded-br-3xl pointer-events-none" data-id="element-354"></div>
        <div className="absolute top-8 right-8 w-16 h-16 border-t border-r border-[rgba(59,130,246,0.1)] rounded-tr-2xl pointer-events-none" data-id="element-355"></div>
        <div className="absolute bottom-8 left-8 w-16 h-16 border-b border-l border-[rgba(59,130,246,0.1)] rounded-bl-2xl pointer-events-none" data-id="element-356"></div>

        {/* Animated floating elements */}
        <div className="absolute top-[20%] left-[10%] w-2 h-2 bg-[#3B82F6] rounded-full opacity-40 animate-ping" style={{
        animationDuration: '3s'
      }} data-id="element-357"></div>
        <div className="absolute top-[30%] right-[15%] w-1.5 h-1.5 bg-[#1D4ED8] rounded-full opacity-30 animate-ping" style={{
        animationDuration: '4s'
      }} data-id="element-358"></div>
        <div className="absolute bottom-[25%] left-[20%] w-1 h-1 bg-[#3B82F6] rounded-full opacity-50 animate-ping" style={{
        animationDuration: '2.5s'
      }} data-id="element-359"></div>
        <div className="absolute bottom-[35%] right-[10%] w-2 h-2 bg-[#1D4ED8] rounded-full opacity-20 animate-ping" style={{
        animationDuration: '5s'
      }} data-id="element-360"></div>

        {/* Decorative rings */}
        <svg className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] pointer-events-none" viewBox="0 0 400 400" fill="none" data-id="element-361">
          <circle cx="200" cy="200" r="180" stroke="#1D4ED8" strokeWidth="0.5" opacity="0.1" strokeDasharray="4 6" data-id="element-362">
            <animateTransform attributeName="transform" type="rotate" from="0 200 200" to="360 200 200" dur="80s" repeatCount="indefinite" data-id="element-363" />
          </circle>
          <circle cx="200" cy="200" r="150" stroke="#3B82F6" strokeWidth="0.3" opacity="0.08" strokeDasharray="2 8" data-id="element-364">
            <animateTransform attributeName="transform" type="rotate" from="360 200 200" to="0 200 200" dur="60s" repeatCount="indefinite" data-id="element-365" />
          </circle>
        </svg>

        <div className="max-w-[900px] mx-auto px-5 md:px-12 text-center relative z-10" data-id="element-366">
          {/* Top badge */}
          <div className="inline-flex items-center gap-2 bg-[rgba(29,78,216,0.15)] border border-[rgba(29,78,216,0.3)] px-5 py-2.5 rounded-full mb-10" data-id="element-367">
            <div className="w-2 h-2 rounded-full bg-[#3B82F6] animate-pulse" data-id="element-368"></div>
            <span className="font-['Montserrat'] text-[11px] font-bold tracking-[0.18em] uppercase text-[#3B82F6]" data-id="element-369">
              PRIMUL PAS SPRE LIBERTATE
            </span>
          </div>

          <h2 className="font-['Montserrat'] text-[clamp(32px,5vw,52px)] font-extrabold text-white mb-8 leading-[1.1] tracking-tight" data-id="element-370">
            Afacerea ta merită să funcționeze{' '}
            <span className="relative inline-block" data-id="element-371">
              <span className="relative z-10" data-id="element-372">fără tine.</span>
              <span className="absolute bottom-1 left-0 w-full h-3 bg-[#1D4ED8] opacity-30 -skew-x-3 rounded" data-id="element-373"></span>
            </span>
          </h2>

          <p className="font-['Inter'] text-[19px] font-light text-[rgba(255,255,255,0.7)] leading-[1.8] mb-12 max-w-[640px] mx-auto" data-id="element-374">
            Rezervă acum o sesiune cadou de diagnostic și hai să vedem împreună
            ce oprește creșterea companiei tale și care e primul pas concret.
          </p>

          {/* CTA Button with glow */}
          <div className="relative inline-block mb-14" data-id="element-375">
            <div className="absolute inset-0 bg-[#1D4ED8] blur-[30px] opacity-40 rounded-2xl scale-110" data-id="element-376"></div>
            <a href="https://calendly.com/valerdura-coaching/sesiune-descoperire" className="relative inline-block font-['Montserrat'] text-[15px] font-bold bg-[#1D4ED8] text-white px-12 py-6 rounded-xl shadow-[0_8px_32px_rgba(29,78,216,0.5)] hover:bg-[#2563EB] hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(29,78,216,0.6)] transition-all duration-300 no-underline" data-id="element-377">
              Rezervă Sesiunea Cadou de Diagnoză →
            </a>
          </div>

          {/* Trust row */}
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12" data-id="element-378">
            <div className="flex items-center gap-2 text-[rgba(255,255,255,0.4)]" data-id="element-379">
              <svg className="w-5 h-5 text-[#3B82F6]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-380">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-381" />
              </svg>
              <span className="font-['Inter'] text-[13px]" data-id="element-382">60 minute</span>
            </div>
            <div className="flex items-center gap-2 text-[rgba(255,255,255,0.4)]" data-id="element-383">
              <svg className="w-5 h-5 text-[#3B82F6]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-384">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-385" />
              </svg>
              <span className="font-['Inter'] text-[13px]" data-id="element-386">100% Gratuit</span>
            </div>
            <div className="flex items-center gap-2 text-[rgba(255,255,255,0.4)]" data-id="element-387">
              <svg className="w-5 h-5 text-[#3B82F6]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-388">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" data-id="element-389" />
              </svg>
              <span className="font-['Inter'] text-[13px]" data-id="element-390">Fără obligații</span>
            </div>
            <div className="flex items-center gap-2 text-[rgba(255,255,255,0.4)]" data-id="element-391">
              <svg className="w-5 h-5 text-[#3B82F6]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-392">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" data-id="element-393" />
              </svg>
              <span className="font-['Inter'] text-[13px]" data-id="element-394">
                1-la-1 cu Valer
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="w-full bg-[#09111F] pt-16 pb-8 border-t border-[rgba(255,255,255,0.08)]" data-id="element-395">
        <div className="max-w-[1200px] mx-auto px-5 md:px-12" data-id="element-396">
          {/* Top Row */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-397">
            {/* Column 1 — Brand + Company Details + Contact */}
            <div data-id="element-398">
              <p className="font-['Montserrat'] text-xl font-bold text-white mb-1 tracking-tight" data-id="element-399">
                Valer Dura
              </p>
              <p className="font-['Inter'] text-[14px] text-[rgba(255,255,255,0.5)] mb-6" data-id="element-400">
                PERFORMANCE COACHING & TRAINING S.R.L.
              </p>

              <div className="space-y-2 mb-6" data-id="element-401">
                <p className="font-['Inter'] text-[13px] text-[rgba(255,255,255,0.4)]" data-id="element-402">
                  CUI: 43061087
                </p>
                <p className="font-['Inter'] text-[13px] text-[rgba(255,255,255,0.4)]" data-id="element-403">
                  Nr. Înmatriculare: J30/1020/2023
                </p>
              </div>

              <div className="space-y-3" data-id="element-404">
                <a href="tel:+40745180514" className="flex items-center gap-3 text-[rgba(255,255,255,0.6)] hover:text-white transition-colors" data-id="element-405">
                  <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-406">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" data-id="element-407" />
                  </svg>
                  <span className="font-['Inter'] text-[14px]" data-id="element-408">
                    +40 745 180 514
                  </span>
                </a>
                <a href="mailto:duravaler@yahoo.com" className="flex items-center gap-3 text-[rgba(255,255,255,0.6)] hover:text-white transition-colors" data-id="element-409">
                  <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-410">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" data-id="element-411" />
                  </svg>
                  <span className="font-['Inter'] text-[14px]" data-id="element-412">
                    duravaler@yahoo.com
                  </span>
                </a>
              </div>
            </div>

            {/* Column 2 — Linkuri Utile */}
            <div data-id="element-413">
              <p className="font-['Montserrat'] text-[15px] font-bold text-white mb-5 tracking-tight" data-id="element-414">
                Linkuri Utile
              </p>
              <div className="space-y-3" data-id="element-415">
                {['Despre Mine', 'Servicii', 'PROVI System', 'Diagnostic Gratuit', 'Contact'].map(link => <a key={link} href="#" className="block font-['Inter'] text-[14px] text-[rgba(255,255,255,0.5)] hover:text-white transition-colors" data-id="element-416">
                    {link}
                  </a>)}
              </div>
            </div>

            {/* Column 3 — Urmărește-mă */}
            <div data-id="element-417">
              <p className="font-['Montserrat'] text-[15px] font-bold text-white mb-5 tracking-tight" data-id="element-418">
                Urmărește-mă
              </p>
              <div className="flex gap-3" data-id="element-419">
                <a href="https://www.facebook.com/valer.dura" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-10 h-10 rounded-full bg-[rgba(255,255,255,0.08)] flex items-center justify-center text-[rgba(255,255,255,0.5)] hover:bg-[#1D4ED8] hover:text-white transition-all duration-300" data-id="element-420">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24" data-id="element-421">
                    <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" data-id="element-422" />
                  </svg>
                </a>
              </div>
            </div>
          </div>

          {/* Divider */}
          <div className="border-t border-[rgba(255,255,255,0.06)] pt-8 mb-8" data-id="element-423">
            {/* Legal Links */}
            <div className="flex flex-wrap justify-center gap-6 mb-8" data-id="element-424">
              {['Politică de Confidențialitate', 'Termeni și Condiții', 'Politică Cookie-uri', 'ANPC'].map(link => <a key={link} href="#" className="font-['Inter'] text-[13px] text-[rgba(255,255,255,0.4)] hover:text-white transition-colors" data-id="element-425">
                  {link}
                </a>)}
            </div>

            {/* ANPC + SOL Logos */}
            <div className="flex flex-wrap justify-center items-center gap-6 mb-8" data-id="element-426">
              <a href="https://anpc.ro/ce-este-sal/" target="_blank" rel="noopener noreferrer" className="bg-white rounded-lg px-2 py-1 hover:opacity-80 transition-opacity" data-id="element-427">
                <img src="https://cdn.magicpatterns.com/uploads/qEkMe7B8gpamVaXefnKexi/ANPC.webp" alt="ANPC — Soluționarea Alternativă a Litigiilor" className="h-12 w-auto" data-id="element-428" />
              </a>
              <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="bg-white rounded-lg px-2 py-1 hover:opacity-80 transition-opacity" data-id="element-429">
                <img src="https://cdn.magicpatterns.com/uploads/dUe8iPkBxBZ1Ryan5hWypX/Solutionarea_Online_a_Litigiilor.jpg" alt="Soluționarea Online a Litigiilor" className="h-12 w-auto" data-id="element-430" />
              </a>
            </div>
          </div>

          {/* Copyright */}
          <div className="border-t border-[rgba(255,255,255,0.06)] pt-6 text-center" data-id="element-431">
            <p className="font-['Inter'] text-[13px] text-[rgba(255,255,255,0.3)]" data-id="element-432">
              © 2026 PERFORMANCE COACHING & TRAINING S.R.L. Toate drepturile
              rezervate.
            </p>
          </div>
        </div>
      </footer>
    </div>;
}